function artistDates(artist) {
  const { year_born: yearBorn, year_died: yearDied } = artist;

  if (yearBorn && yearDied) {
    return `(${yearBorn}–${yearDied})`;
  } else if (yearBorn) {
    return `(b.${yearBorn})`;
  }

  return "";
}

export { artistDates };
